import { render, staticRenderFns } from "./live.vue?vue&type=template&id=2ddd5b00&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=2ddd5b00&prod&scoped=true&lang=css"
import style1 from "./live.vue?vue&type=style&index=1&id=2ddd5b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddd5b00",
  null
  
)

export default component.exports